<div class="principal">
    <h1 class="textoPrincipal">Seja Bem vindo ao E-Transport !!!</h1>
    <h2 class="textoSec">Portal desenvolvido para acompanhamento do Fluxo de transportes.</h2>
    <!-- <img src="assets/Assinatura_500K.png" alt="Descrição da Imagem" class="imagemPrincipal"> -->

    <!-- <div style="text-align:center;">
        <h1>Teste Subscription</h1>
        <button (click)="subscribe()">Testar Subscription</button>
      </div>

      <div>
        <h1>Enviar Notificação</h1>
        <button (click)="sendNotification()">Enviar Notificação</button>
      </div>

      <div>
        <h1>Escaneie o QR Code para se inscrever nas notificações</h1>
        <input type="text" name="senha" [(ngModel)]="idSenha" class="modal-input0">
        <input type="text" name="guiche" [(ngModel)]="guiche" class="modal-input0">
        <button (click)="generateQrCode()">Gerar QR Code</button>
        <div id="qrcode"></div>
      </div>

      <div>
        <h1>Inscrição para Notificações</h1>
        <p>Você está se inscrevendo para receber notificações. Por favor, permita as notificações para continuar.</p>
      </div> -->
</div>